<template>
   
    <div class="part-member-num" v-if="item.paperUserList != null"> 
        <div class="droplayer relative">
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">
                        {{ defaultLanguage.indexOf('ko') != -1 ? item.regUserName : item.regUserNameEn != null ? item.regUserNameEn : item.regUserName }} 
                        <span class="num">{{ checkMember(item.paperUserList.length) }}</span>
                    </v-btn>
                </template>
                <div class="dropdown-list">
                    <div class="top" v-html="$i18nUtil.trans('search.000.people','총 {cnt} 명', {cnt: item.paperUserList.length})"></div>
                    <div class="scroll">
                        <div class="members_box">
                            {{memberList()}} 
                        </div>
                    </div>
                </div>
            </v-menu>
        </div>
    </div> 
</template>
<script>
export default {
    props:["item"],
    data() {
        return {
            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
        }
    },
    methods: {
        checkMember(memberNumber){
            return memberNumber > 999 
                    ? '999+' 
                    : memberNumber == 1
                        ? ''
                        : memberNumber;
        },
        memberList(){ 
            let obj = this;
            let userString = '';  
            this.item.paperUserList.forEach(function(user){
                userString += (obj.defaultLanguage.indexOf('ko') != -1 ? user.userName : user.userNameEn != null ? user.userNameEn : user.userName) +", ";
            })
              
            userString = userString.trim(); 
            userString = userString.substring(0,userString.length-1); 
            return userString;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/manage/components/CooperationBoardMember.vue